import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { ExportTableFileNameCell } from '../components/ExportTableFileNameCell';
import { IExportRow } from '../interfaces/IExportRow';

export const initialExportTableColumns: ITableColumn<IExportRow>[] = [
  {
    id: 'id',
    name: 'Номер выгрузки',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'uploadId',
    name: 'Номер выгружаемого объекта',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'type',
    name: 'Тип выгружаемого файла',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'file.filename',
    name: 'Имя файла',
    sort: TableColumnSortEnum.NONE,
    renderCell: ExportTableFileNameCell,
  },
  {
    id: 'created',
    name: 'Дата создания задачи',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'formed',
    name: 'Дата формирования файла выгрузки',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'status',
    name: 'Статус',
    sort: TableColumnSortEnum.NONE,
  },
];
